<template>
  <div>
    <el-form
      :model="enterpriseFrom"
      label-width="150px"
      ref="ruleForm3"
      class="demo-ruleForm"
      v-loading="contentLoading"
    >
      <el-form-item
        label="法人姓名"
        prop="etpLegal"
        :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
      >
        <el-input
          size="medium"
          v-model="enterpriseFrom.etpLegal"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="法人证件类型" prop="etpLegalIdcardType">
        <el-select
          style="width: 100%"
          disabled
          v-model="enterpriseFrom.etpLegalIdcardType"
          placeholder="身份证"
        >
          <el-option key="身份证" label="身份证" value="身份证"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="法人身份证号"
        prop="etpLegalIdcardCode"
        :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
      >
        <el-input
          size="medium"
          v-model="enterpriseFrom.etpLegalIdcardCode"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="法人手机号"
        prop="etpLegalPhone"
        :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
      >
        <el-input
          size="medium"
          v-model="enterpriseFrom.etpLegalPhone"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="法人证件有效期"
        prop="etpLegalIdcardDateBegin"
        :rules="[{ required: true, message: '请选择', trigger: 'blur' }]"
      >
        <el-date-picker
          style="width: 48%"
          v-model="enterpriseFrom.etpLegalIdcardDateBegin"
          type="date"
          placeholder="选择开始日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-date-picker
          style="float: right; width: 48%"
          v-model="enterpriseFrom.etpLegalIdcardDateEnd"
          type="date"
          placeholder="选择结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="法人证件正面照片"
        prop="etpLegalIdcardPicZm"
        :rules="[{ required: true, message: '请上传', trigger: 'blur' }]"
      >
        <upLoadImg
          v-model="enterpriseFrom.etpLegalIdcardPicZm"
          limit="1"
          @syncFileIds="etpLegalIdcardPicZmBtn"
        >
        </upLoadImg>
      </el-form-item>
      <el-form-item
        label="法人证件背面面照片"
        prop="etpLegalIdcardPicFm"
        :rules="[{ required: true, message: '请上传', trigger: 'blur' }]"
      >
        <upLoadImg
          v-model="enterpriseFrom.etpLegalIdcardPicFm"
          limit="1"
          @syncFileIds="etpLegalIdcardPicBtn"
        >
        </upLoadImg>
      </el-form-item>
    </el-form>
    <el-button
      style="width: 100%"
      size="medium"
      type="primary"
      @click="etpBtn('ruleForm3')"
      >保存</el-button
    >
  </div>
</template>

<script>
import { updateC, detailC } from '@/api/user/company'
import upLoadImg from '@/components/uploadImg/index.vue'
import { parseTime } from '@/utils/DateUtils'
export default {
  components: {
    upLoadImg
  },
  data() {
    return {
      contentLoading: false,
      enterpriseFrom: {
        etpLegal: '', // 法人姓名
        etpLegalIdcardType: '身份证', // 法人证件类型
        etpLegalIdcardCode: '', // 法人证件号码
        etpLegalIdcardDateBegin: '', // 法人证件开始日期
        etpLegalIdcardDateEnd: '', // 法人证件结束日期
        etpLegalPhone: '', // 法人手机号
        etpLegalIdcardPicFm: '', // 法人证件照（反面）
        etpLegalIdcardPicZm: '' // 法人证件照（正面）
      }
    }
  },
  mounted() {
    this.getComanyInfo()
  },
  methods: {
    etpLegalIdcardPicZmBtn(v) {
      this.enterpriseFrom.etpLegalIdcardPicZm = v
    },
    etpLegalIdcardPicBtn(v) {
      this.enterpriseFrom.etpLegalIdcardPicFm = v
    },
    getComanyInfo() {
      this.contentLoading = true
      const data = {}
      detailC(data).then((res) => {
        if (res.success) {
          this.enterpriseFrom = res.result

          this.enterpriseFrom.etpLegalIdcardDateBegin =
            parseTime(this.enterpriseFrom.etpLegalIdcardDateBegin) || ''
          this.enterpriseFrom.etpLegalIdcardDateEnd =
            parseTime(this.enterpriseFrom.etpLegalIdcardDateEnd) || ''
        }
        this.contentLoading = false
      })
    },
    etpBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 法人信息保存
          if (this.enterpriseFrom.etpLegalIdcardDateBegin) {
            this.enterpriseFrom.etpLegalIdcardDateBegin = Date.parse(
              this.enterpriseFrom.etpLegalIdcardDateBegin
            )
          }
          if (this.enterpriseFrom.etpLegalIdcardDateEnd) {
            this.enterpriseFrom.etpLegalIdcardDateEnd = Date.parse(
              this.enterpriseFrom.etpLegalIdcardDateEnd
            )
          }
          updateC(this.enterpriseFrom).then((res) => {
            if (res.success) {
              this.$message.success('法人信息维护成功')
              this.$emit('childEditBtn')
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
